import { useTranslation } from 'react-i18next';

import { ErrorState } from '~/components';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['quotations']);

  return <ErrorState onRetry={() => window.location.reload()} title={t('quotations:quotationForClient.error.title')} />;
};
